import React from 'react';
import type { WarmTransferDemoState } from '../../warm-transfer/types';
import { useNowMinute } from '../../warm-transfer/utils';
import { IconButton } from '../IconButton/IconButton';

const DEMO_OPTIONS: { id: WarmTransferDemoState; label: string }[] = [
  { id: 'active', label: 'Active queue' },
  { id: 'quiet', label: 'All quiet' },
];

export interface WarmTransferTopBarActionsProps {
  demoState: WarmTransferDemoState;
  onDemoStateChange: (state: WarmTransferDemoState) => void;
  onHelp?: () => void;
  onBell?: () => void;
}

export function WarmTransferTopBarActions({
  demoState,
  onDemoStateChange,
  onHelp,
  onBell,
}: WarmTransferTopBarActionsProps) {
  const time = useNowMinute();

  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <div className="inline-flex gap-px rounded-[9px] border border-[var(--cream-2)] bg-[var(--surface-mute)] p-0.5">
        {DEMO_OPTIONS.map((option) => {
          const active = demoState === option.id;
          return (
            <button
              key={option.id}
              type="button"
              onClick={() => onDemoStateChange(option.id)}
              className={[
                'cursor-pointer rounded-[7px] border-0 px-[11px] py-[5px] text-[12px] leading-none tracking-[-0.005em] transition-[background,color,box-shadow] duration-200',
                active
                  ? 'bg-[var(--cream-1)] font-semibold text-[var(--ink-0)] shadow-[var(--sh-1)]'
                  : 'bg-transparent font-medium text-[var(--ink-2)]',
              ].join(' ')}
            >
              {option.label}
            </button>
          );
        })}
      </div>

      <span
        className="inline-flex h-8 items-center gap-1.5 rounded-[9px] border px-2.5"
        style={{
          background: 'rgba(15, 92, 69, 0.05)',
          borderColor: 'rgba(15, 92, 69, 0.10)',
        }}
      >
        <span className="elva-live h-[6px] w-[6px]" />
        <span className="text-[11.5px] font-semibold tracking-[0.01em]" style={{ color: '#0A4530' }}>
          Live
        </span>
        <span className="wt-mono ml-0.5 text-[11px] text-[var(--ink-2)]">{time}</span>
      </span>

      <IconButton
        icon="help"
        size={32}
        onClick={onHelp}
        label="Help"
        className="rounded-[9px] border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-1)] hover:bg-[var(--surface-mute)]"
      />
      <div className="relative">
        <IconButton
          icon="bell"
          size={32}
          onClick={onBell}
          label="Notifications"
          className="rounded-[9px] border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-1)] hover:bg-[var(--surface-mute)]"
        />
        <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-[var(--terracotta)] shadow-[0_0_0_2px_var(--cream-1)]" />
      </div>
    </div>
  );
}
